import { RouteRecordRaw } from '@bv/router';

import { integrationsBreadcrumbs } from '@/router/main/breadcrumbs';
import { canAccessIntegrations } from '@/utils/workspace-info';

import { mcpRoute } from './mcp';
import { sallaRoutes } from './salla.routes';
import { webhooksRoutes } from './webhooks.routes';

export const integrationsRoutes: RouteRecordRaw = {
  path: '/integrations',
  name: 'integrations',
  redirect: { name: 'int-marketplace' },
  meta: {
    canAccess: canAccessIntegrations,
    header: { title: 'integrations.title_trans', icon: 'bvi-integration' },
    sidebar: [
      {
        title: 'integrations.marketplace.title_trans',
        route: { name: 'int-marketplace' },
        icon: 'bvi-bag',
      },
      {
        title: 'integrations.api_key.title_trans',
        route: { name: 'int-api' },
        icon: 'bvi-code-circle',
      },
      {
        title: 'integrations.webhooks.title_trans',
        items: [
          {
            title: 'integrations.webhooks.title_trans',
            route: { name: 'int-webhooks' },
            icon: 'bvi-webhook',
          },
          {
            title: 'integrations.webhooks.logs.title_trans',
            route: { name: 'int-webhook-logs' },
            icon: 'bvi-notebook',
          },
        ],
      },
    ],
  },
  children: [
    ...webhooksRoutes,
    {
      path: 'api',
      name: 'int-api',
      meta: {
        breadcrumbs: integrationsBreadcrumbs({
          label: 'integrations.api_key.title_trans',
          route: { name: 'int-api' },
        }),
      },
      component: () => import('@/components/integrations/api-key/ApiKey.vue'),
    },
    {
      path: 'marketplace',
      name: 'int-marketplace',
      meta: {
        breadcrumbs: integrationsBreadcrumbs({
          label: 'integrations.marketplace.title_trans',
          route: { name: 'int-marketplace' },
        }),
      },
      component: () => import('@/views/Main/integrations/marketplace/MarketplaceView.vue'),
    },
    sallaRoutes,
    mcpRoute,
  ],
};
